import React from 'react'
import {Link} from 'react-router-dom'

const DevotionalHomeImageCard = (props) => {

        const {imageCard}=props
  return (
    <div className='col-4'>
       <Link to={imageCard.url} className='devotional-home-image-card' target={imageCard.url?.includes('/subpages/') ? '_self' : '_blank'} rel='noopener noreferrer' ><img src={imageCard.img_url} alt="img-card" /></Link>
    </div>
  )
}

export default DevotionalHomeImageCard;
